<template>
    <div>
        <div class="page-title-box-spacing">
            <template v-if="isMobile">
                <div class="row p-0">
                    <div :class="isMobile ? 'col-12 text-center' : 'col-auto p-0'">
                        <div class="d-inline-block">
                            <div class="d-flex align-items-center topbar-right-spacing name-header" :class="isMobile && 'm-0'">
                                <div>Անժամկետ տենդերներ</div>
                                <button
                                    type="button"
                                    class="btn btn-primary p-0 ml-4 px-2"
                                    @click="openRegulationsModal"
                                >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8ZM9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10V14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14V10Z" fill="#006BE6"/>
                                    </svg>
                                    <span class="text-white ml-1">Կանոնակարգ</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="row justify-content-between align-items-center m-0 p-0">
                    <div class="col-auto p-0">
                        <div class="d-inline-block">
                            <div class="d-flex align-items-center topbar-right-spacing name-header">
                                <div>Անժամկետ տենդերներ</div>
                                <button
                                    type="button"
                                    class="btn btn-primary p-0 ml-2 px-2"
                                    @click="openRegulationsModal"
                                >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8ZM9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10V14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14V10Z" fill="#006BE6"/>
                                    </svg>
                                    <span class="text-white ml-1">Կանոնակարգ</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="card">
            <div class="card-body p-0">
                <div
                    class="row m-0 w-100 align-items-center padding-l-10 padding-r-10 padding-t-10 justify-content-start filter-block"
                >
                    <div v-if="selectedCategory?.value" @click="removeSelectedCategory" class="pointer d-flex align-items-center justify-content-center padding-b-20 padding-l-10 padding-t-10">
                        <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.2069 10.4194L14.7931 5L16.5 6.65591L10.9138 12.0753L16.5 17.3441L14.7931 19L9.2069 13.7312L7.5 12.0753L9.2069 10.4194Z" fill="#006BE6"/>
                        </svg>
                    </div>
                    <div
                        v-if="selectedCategory?.value"
                        class="cpv-select-block padding-b-20 padding-r-10 padding-l-10 padding-t-10"
                    >
                        <div
                            type="button"
                            @click="$modal.show('add-cpv-modal', handleAddRows)"
                            class="cpv-select-btn tender-input form-control"
                        >
                            <template v-if="cpvs.length">
                                <span :key="cpv.id" v-for="cpv in cpvs">
                                    Կատեգորիա։ {{ cpv.name }}
                                </span>
                                <svg
                                    v-tooltip="'Հեռացնել ընտրված կատեգորիան'"
                                    @click="deleteElements"
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M5.34033 0H11.6103V1.5H5.34033V0ZM0.730469 3.29004H16.2305V4.79004H14.7305V15.59C14.7278 16.0534 14.5426 16.497 14.215 16.8246C13.8874 17.1522 13.4438 17.3374 12.9805 17.34H3.98047C3.51634 17.34 3.07122 17.1557 2.74303 16.8275C2.41484 16.4993 2.23047 16.0542 2.23047 15.59V4.79004H0.730469V3.29004ZM3.73047 15.79L13.1805 15.84L13.2205 4.79004H3.73047V15.79Z"
                                        fill="#E02232"
                                    />
                                </svg>
                            </template>
                            <template v-else>
                                <span>Ընտրել կատեգորիա</span>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M18.5 12.9251L18.5 11.0749H12.925V5.5H11.0749V11.0749H5.5V12.9251H11.0749V18.5H12.925L12.925 12.9251H18.5Z"
                                        fill="#006BE6"
                                    />
                                </svg>
                            </template>
                        </div>
                    </div>
                    <SearchInput @handleSearch="handleSearch" />
                    <div v-tooltip="'Ավելացնել անժամկետ տենդերներ'" class="padding-b-20 padding-r-10 padding-t-10 padding-l-10">
                      <button
                        type="button"
                        @click="() => {$router.push('/timeless-tenders/buy/add')}"
                        class="btn btn-primary"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                    <div
                        class="col h-100 d-flex align-items-center justify-content-start padding-b-20 padding-r-10 padding-l-10 padding-t-10"
                    >
                        <div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.1914 16.04H12.7268V11.0299H11.1914V16.04Z"
                                    fill="#006BE6"
                                />
                                <path
                                    d="M12.8076 7.87891H11.1914V9.49507H12.8076V7.87891Z"
                                    fill="#006BE6"
                                />
                                <path
                                    d="M12 4C7.55556 4 4 7.55556 4 12C4 16.4444 7.55556 20 12 20C16.4444 20 20 16.4444 20 12C20 7.55556 16.3636 4 12 4ZM12 18.303C8.44444 18.303 5.61616 15.4747 5.61616 12C5.61616 8.52525 8.44444 5.61616 12 5.61616C15.5556 5.61616 18.3838 8.44444 18.3838 12C18.3838 15.5556 15.4747 18.303 12 18.303Z"
                                    fill="#006BE6"
                                />
                            </svg>
                        </div>
                        <div class="pl-2">
                            <span class="small">
                                Ուշադրություն ! Այս հարթակից օգտվելու համար
                                անհրաժեշտ է ունենալ ID և ակտիվացված Բջջային
                                էլեկտրոնային թվային ստորագրություն
                                <a
                                    href="https://ekeng.am/hy/mid_auth"
                                    target="_blank"
                                    class="small pointer font-weight-bold text-primary"
                                    >(mID)
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row w-100 m-0">
                    <div class="col-12 tenders-list p-0">
                        <div
                            class="d-flex flex-wrap gap-2 padding-r-10 padding-l-10 tender-cards-block"
                        >
                            <template v-if="hasSelectedCategory">
                                <tender-card
                                    @click="
                                        $router.push(
                                            `/timeless-tenders/tender/${tender.id}`
                                        )
                                    "
                                    :tender="tender"
                                    :selectedType="'all'"
                                    :can-favorite="true"
                                    :can-edit="false"
                                    v-for="tender in tenders"
                                    :key="tender.id"
                                />
                            </template>
                            <template v-else>
                                <category-card
                                    :category="category"
                                    :selectedCategory="selectedCategory"
                                    @clickMethod="handleSelectCategory"
                                    :show-count="true"
                                    v-for="(category,
                                    index) in timelessTendersCategories"
                                    :key="index"
                                />
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <add-cpv-modal :closable="false" />
            <timeless-tender-regulations-modal />
        </div>
    </div>
</template>
<script>
import AddCpvModal from './modals/AddCpvModal.vue'
import TenderCard from '@/components/timelessTenders/tenderCard.vue'
import SearchInput from '@/components/timelessTenders/SearchInput.vue'
import CategoryCard from '@/components/timelessTenders/categoryCard.vue'
import TimelessTenderRegulationsModal from '@/components/modals/TimelessTenderRegulationsModal.vue'
import isMobile from '@/mixins/isMobileView'

export default {
    mixins: [isMobile],
    components: { CategoryCard, SearchInput, TenderCard, AddCpvModal, TimelessTenderRegulationsModal },
    data() {
        return {
            dateNow: new Date(),
            backendUrl: process.env.VUE_APP_URL,
            tenders: [],
            allTenders: [],
            selectedCategory: {},
            categoryCounts: {},
            hasSelectedCategory: false,
            searchQuery: '',
            cpvs: [],
            columns: [
                'password',
                'title',
                'products',
                'opening_finish_date',
                'price',
                'region',
                'type',
                'invitation',
                'edit',
                'participants_count',
            ],
        }
    },
    computed: {
        currentPlan() {
            return this.$store.getters['procurement/currentPlan']
        },
        locale() {
            return this.$store.getters['user/locale']
        },
        timelessTendersCategories() {
            const base = this.$store.getters['settings/timelessTendersCategories'];
            return base.map((category) => ({
                ...category,
                count: this.categoryCounts?.[category.value] || 0
            }));
        },
    },
    mounted() {
        this.getTenders()
    },
    methods: {
        openRegulationsModal() {
            this.$modal.show('timeless-regulations-modal')
        },
        removeSelectedCategory(){
            this.selectedCategory = {}
            this.hasSelectedCategory = false
        },
        handleSelectCategory(category) {
            if(category.count){
                this.selectedCategory = category
                this.hasSelectedCategory = true
                this.getTenders()
            }
        },
        handleSearch(query) {
            this.searchQuery = query
            this.getTenders()
        },
        deleteElements() {
            this.cpvs = []
            this.getTenders()
        },
        getTenders() {
            this.$client
                .get('timeless-tenders', {
                    params: {
                        cpvs: this.cpvs.length
                            ? this.cpvs.map((cpv) => cpv.id)
                            : null,
                        type: 'all',
                        category: this.selectedCategory?.value ?? '',
                        query: this.searchQuery,
                    },
                })
                .then(({ data }) => {
                    if (!this.hasSelectedCategory) {
                        this.allTenders = data.data;
                        this.updateCategoryCounts();
                    } else {
                        this.tenders = data.data;
                    }
                })
                .finally(() => {
                    this.refreshTimelessMenuNotifications();
                });
        },
        updateCategoryCounts() {
            const counts = {};
            this.allTenders.forEach((tender) => {
                const category = tender.category;
                if (category) {
                    counts[category] = (counts[category] || 0) + 1;
                }
            });
            this.categoryCounts = counts;
        },
        handleAddRows(rows) {
            console.log(rows)
            this.cpvs = rows
            console.log(this.filter)
            this.getTenders()
        },
        refreshTimelessMenuNotifications() {
            this.$store.dispatch('user/getMenuNotifications')
        },
    },
}
</script>
<style scoped>
.cpv-select-block {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    .cpv-select-btn {
        height: 36px;
        width: 365px;
        margin: 0 !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #2d3036;
        }
    }
}
@media (max-width: 1024px) {
    .cpv-select-block,
    .cpv-search-block {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
    }
    .cpv-select-btn {
        width: 100% !important;
    }
}

@media (max-width: 480px) {
    .tender-cards-block {
        padding: 20px 0 !important;
    }
    .filter-block {
        flex-direction: column !important;
    }
    .cpv-select-block,
    .cpv-search-block {
        width: 100% !important;
        padding: 0 !important;
    }
    .cpv-search-block {
        padding: 20px 0 0 0 !important;
    }
}
</style>
